module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAUdJREFUOE9jZKASYKSSOQzUN2hmpJQGCzPTZsb/jCzIrvzP+O/Jv/8MkcyMjIvRXf/777/M9OXPboDE4S6aHSPjwMzAuB+bV7///MHLycYWDJNjYvh/J2Hps6PIaoky6Pffv6KsTMzpjIz/wa79+5fxYsryxxtINuj7zx+SnOzsyyn22qMnj1llpCSlkQ36+fvP2+zVr7/AxOBemxkpJcLGxNzMwMDAgazhHwPDlR+/fizlYuNoR4mE/3+XJi17tgfDoDkxoiqM/zmqSUlX/xl/tKYseX0HJdbmOzBwMEhISJBi0MMXL540HGD4g2IQKB2xMjNNJ8qg///3JC192oo11qaGikpwsbOnE2UQKAH++7slYdnzsxhhND9AQOAfF3cAsQb9Z2I8krLkCTh8yPLa////HyQvfZqIbiH1My2xXsKljmouAgDk+ncT4ea5hwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SearchPage/content.png
// module id = cDH0
// module chunks = 1